export default "__VITE_ASSET__CTrzbQnE__"